/**
 * MFormula — Quantity Break Description Drawer
 * File: assets/mformula-variant-desc-drawer.js
 *
 * 抽屉的开合已经全部交给 CSS，这支档案本来是空的占位符。
 * 现在它装着底下的 PWP（购买附加购买）机制。
 */

/* =====================================================================
 * PWP 购物车优惠码 —— v3（2026-08-19）
 *
 * 【新增一个 PWP 要做什么】
 *   1. 建产品，handle 设成  pwp-<折扣码小写>，状态 UNLISTED，上架 Online Store
 *   2. 在后台建那个折扣码
 *   完成。这支档案一个字都不用改。
 *
 * 【v3：全程不跳页】
 *   Shopify 从 2025-05 起，/cart/update.js 支援 discount 参数，可以直接套用和
 *   移除折扣码。在那之前只能跳去 /discount/CODE 再跳回来（画面会闪一下），
 *   现在不用了。顾客打完码，东西原地出现。
 *
 *   ⚠ 五个实测出来的坑（2026-08-19，改这支档案前务必看完）：
 *   (1) 码打错时 Shopify 回 HTTP 200、不给任何错误讯息，而且会把顾客原本
 *       套好的码一起洗掉。→ 一定要自己比对有没有真的套上，失败就把旧码装回去。
 *   (2) 一次传两个码（'A,B'）只会套上第一个能用的，另一个被默默丢掉。
 *       → 套新码只能单传，不可以连旧码一起传，否则新码永远套不上。
 *   (3) paint() 重画之后，我们整个促销框会被主题换掉。要给顾客看的讯息
 *       一律用 showMsg()（它会存起来让重建的框接手），不可以直接写 msgEl，
 *       否则写进去的是已经被丢掉的元素，顾客什么都看不到。
 *   (4) 重画后【不可以】坐等 MutationObserver 把框装回去，也不可以用 setTimeout —
 *       它是节流的，背景分页（visibilityState=hidden）会被拖慢到 ~1 秒，框会失踪。
 *       2026-08-19 实测：隐藏分页里 setTimeout(60) 变成约 1000ms。
 *       所以 renderContents 之后【同一个 tick 同步】叫 mount()，浏览器还没重绘就补好。
 *   (5) 购物车 API 打太密会被限流：HTTP 429，回传一页 HTML 而不是 JSON。
 *
 * 【为什么要拦截 fetch：别拿掉】
 *   顾客在侧边抽屉里加减商品走的是 AJAX，不会重整页面。
 *   若只在页面载入时检查，顾客在抽屉里删掉主商品时，PWP 商品会留在车里
 *   【照原价收钱】—— 2026-08-18 在上线版实测踩到：删掉 4 Box 之后，
 *   RM288 的 Bro Deal 留在车里，小计 RM288，没有移除也没有提示。
 *
 * 保险：折扣没套上的 PWP 商品一律自动移除 —— 绝不让顾客付原价。
 *
 * ⚠ 中／英／马来文字写死在这里，Translate & Adapt 管不到。
 * ===================================================================== */
(function () {
  var PREFIX     = 'pwp-';
  var MARK       = '_pwp';
  var REOPEN_KEY = 'mf-pwp-reopen';
  var MSG_KEY    = 'mf-pwp-msg';
  var lastCart   = null;
  var pendingMsg = null;
  var busy       = false;   // 自动检查进行中
  var working    = false;   // 顾客按了套用／移除，处理中
  var tried      = {};      // 这一页已经帮忙补过码的，不重复补

  if (window.Shopify && window.Shopify.designMode) return;

  var lang = (document.documentElement.lang || 'en').toLowerCase();
  var L = lang.indexOf('zh') === 0 ? 'zh' : (lang.indexOf('ms') === 0 ? 'ms' : 'en');
  var T = {
    en: { label: 'Promo Code', ph: 'Enter code', apply: 'Apply', working: 'Working...',
          applied: 'Applied', remove: 'Remove',
          notApplied: "This code doesn't apply to your current cart.",
          failed: 'Could not apply. Please try again.' },
    zh: { label: '优惠码', ph: '输入优惠码', apply: '套用', working: '处理中…',
          applied: '已套用', remove: '移除',
          notApplied: '这个码不适用你目前的购物车。',
          failed: '套用失败，请再试一次。' },
    ms: { label: 'Kod Promosi', ph: 'Masukkan kod', apply: 'Guna', working: 'Sedang diproses...',
          applied: 'Digunakan', remove: 'Buang',
          notApplied: 'Kod ini tidak boleh digunakan untuk troli anda.',
          failed: 'Gagal digunakan. Sila cuba lagi.' }
  }[L];

  function stash(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function grab(k) { try { var v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v; } catch (e) { return null; } }
  function money(c) { return 'RM' + (Math.round(c) / 100).toFixed(2); }
  function up(s) { return String(s == null ? '' : s).trim().toUpperCase(); }

  /* 我们自己的请求一律走 rawFetch，所以永远不会触发下面那个拦截器，不必另外防呆。
     注意：这一行必须在改写 window.fetch 之前执行。 */
  var rawFetch = window.fetch.bind(window);

  function sectionIds() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.getSectionsToRender !== 'function') return null;
    try { return cd.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { return null; }
  }
  function post(url, payload) {
    /* 顺便请 Shopify 把重画好的区块 HTML 一起回传，才能原地更新画面 */
    var ids = sectionIds();
    if (ids && ids.length) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }
  function getCart() {
    return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function findPwp(code) {
    return rawFetch('/products/' + PREFIX + encodeURIComponent(code.toLowerCase()) + '.js',
                    { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function setDiscount(codes) { return post('/cart/update.js', { discount: codes }); }

  /* 原地重画主题自己的购物车画面。画不动就回 false，由呼叫端决定要不要整页重整。 */
  function paint(state) {
    if (window.location.pathname.indexOf('/cart') === 0) return false;   // /cart 页要整页重整才对
    var cd = document.querySelector('cart-drawer');
    if (!state || !state.sections || !cd || typeof cd.renderContents !== 'function') return false;
    try {
      cd.renderContents(state);
      /* 重画把我们的框一起换掉了，同一个 tick 就同步装回去（浏览器还没重绘，零空档）。
         不可以用 setTimeout —— 背景分页会把它拖慢到 ~1 秒，框会失踪。 */
      mount();
      renderChips(lastCart);
      return true;
    } catch (e) { return false; }
  }
  function paintOrReload(state) {
    if (paint(state)) return true;
    stash(REOPEN_KEY, '1');
    window.location.reload();
    return false;
  }

  function pwpLines(cart) {
    var out = [];
    ((cart && cart.items) || []).forEach(function (i) { if (i.properties && i.properties[MARK]) out.push(i); });
    return out;
  }
  function discounted(l) { return l.final_line_price < l.original_line_price; }
  function appliedCodes(cart) {
    var map = {};
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (d) {
      if (d.type !== 'discount_code') return;
      map[d.title] = (map[d.title] || 0) + (d.total_allocated_amount || 0);
    });
    ((cart && cart.items) || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        var da = a.discount_application || {};
        if (da.type !== 'discount_code') return;
        map[da.title] = (map[da.title] || 0) + (a.amount || 0);
      });
    });
    return Object.keys(map).map(function (k) { return { code: k, amount: map[k] }; });
  }
  function hasCode(cart, code) {
    return appliedCodes(cart).some(function (d) { return up(d.code) === up(code); });
  }

  /* 给顾客看的讯息一律走这里 —— 存进 pendingMsg，重建的框会接手，
     这样就算购物车刚被重画、旧框被丢掉，讯息也不会不见。 */
  function showMsg(text) {
    pendingMsg = text;
    document.querySelectorAll('.mf-code-box p').forEach(function (p) { p.textContent = text; p.style.display = 'block'; });
    setTimeout(function () { pendingMsg = null; }, 8000);
  }

  function renderChips(cart) {
    var list = cart ? appliedCodes(cart) : [];
    document.querySelectorAll('.mf-code-chips').forEach(function (box) {
      box.innerHTML = '';
      if (!list.length) { box.style.display = 'none'; return; }
      box.style.display = 'flex';
      list.forEach(function (d) {
        var chip = document.createElement('span');
        chip.style.cssText = 'display:inline-flex;align-items:center;padding:4px 4px 4px 10px;border-radius:999px;background:#e6f2ec;color:#1c5c46;font-size:12px;font-weight:700;letter-spacing:.02em';
        var txt = document.createElement('span');
        txt.textContent = '✓ ' + T.applied + ' ' + d.code + (d.amount ? '  −' + money(d.amount) : '');
        var x = document.createElement('button');
        x.type = 'button';
        x.textContent = '×';
        x.title = T.remove;
        x.setAttribute('aria-label', T.remove + ' ' + d.code);
        x.style.cssText = 'margin-left:8px;width:24px;height:24px;flex:0 0 24px;padding:0;border:0;border-radius:999px;background:rgba(28,92,70,.14);color:#1c5c46;font:inherit;font-size:16px;line-height:1;cursor:pointer;display:inline-flex;align-items:center;justify-content:center';
        x.addEventListener('click', function () { removeCode(d.code, x); });
        chip.appendChild(txt); chip.appendChild(x); box.appendChild(chip);
      });
    });
  }

  /* 顾客自己按 × 拿掉某个码。
     带着那个码的 PWP 商品要一起拿掉，否则会留在车里照原价收。 */
  function removeCode(code, btn) {
    if (working) return;
    working = true;
    if (btn) { btn.disabled = true; btn.style.opacity = '.45'; }
    var keep = appliedCodes(lastCart).map(function (d) { return d.code; })
                 .filter(function (c) { return up(c) !== up(code); });

    getCart().then(function (cart) {
      var mine = pwpLines(cart).filter(function (l) { return up(l.properties[MARK]) === up(code); })[0];
      var chain = mine ? post('/cart/change.js', { id: mine.key, quantity: 0 }) : Promise.resolve(null);
      return chain.then(function () { return setDiscount(keep.join(',')); });
    }).then(function (state) {
      return getCart().then(function (cart) {
        lastCart = cart; tried = {};
        paintOrReload(state);
        renderChips(cart);
      });
    }).catch(function (e) {
      console.warn('[PWP]', e);
      if (btn) { btn.disabled = false; btn.style.opacity = ''; }
    }).then(function () { working = false; });
  }

  function applyCode(raw, msgEl, btn) {
    var code = up(raw);
    if (!code || working) return;
    working = true;
    if (msgEl) msgEl.style.display = 'none';
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = T.working;

    function done() { working = false; btn.disabled = false; btn.textContent = label; }
    function fail(text) { showMsg(text); done(); }

    var before = [];

    /* 拿购物车和查 PWP 产品互不相干，同时做 —— 少等一趟来回 */
    Promise.all([getCart(), findPwp(code)]).then(function (r) {
      var cart = r[0], product = r[1];
      before = appliedCodes(cart).map(function (d) { return d.code; });   // 失败时要装回去
      var vid = product && product.variants && product.variants[0] && product.variants[0].id;
      if (!vid) return null;                       // 不是 PWP，只是普通折扣码

      var mine = null, chain = Promise.resolve();
      pwpLines(cart).forEach(function (l) {
        if (l.variant_id === vid && !mine) { mine = l; return; }
        chain = chain.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); });
      });
      return chain.then(function () {
        if (mine) return null;
        var props = {}; props[MARK] = code;
        return post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: props }] });
      });
    }).then(function () {
      return setDiscount(code);                    // ← 单传，不可以连旧码一起传
    }).then(function (state) {
      return getCart().then(function (cart) {
        if (hasCode(cart, code)) {
          lastCart = cart; tried = {};
          paintOrReload(state);
          renderChips(cart);
          done();
          return;
        }
        /* 套不上。Shopify 不会讲，还顺手把旧码洗掉了 —— 自己收拾干净。
           这条路不要 paint：恢复之后画面跟之前一模一样，重画只会白闪一下。 */
        var mine = pwpLines(cart).filter(function (l) { return up(l.properties[MARK]) === code; })[0];
        var chain = mine ? post('/cart/change.js', { id: mine.key, quantity: 0 }) : Promise.resolve(null);
        return chain.then(function () { return setDiscount(before.join(',')); })
          .then(function () {
            return getCart().then(function (c2) {
              lastCart = c2;
              renderChips(c2);
              fail(T.notApplied);
            });
          });
      });
    }).catch(function (e) {
      console.warn('[PWP]', e);
      fail(T.failed);
    });
  }

  function dropLine(line) {
    if (!line) return;
    return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function (state) {
      return getCart().then(function (cart) {
        lastCart = cart;
        if (paint(state)) { renderChips(cart); showMsg(T.notApplied); }
        else { stash(MSG_KEY, T.notApplied); stash(REOPEN_KEY, '1'); window.location.reload(); }
      });
    });
  }

  /* 核心检查。页面载入、以及【每一次购物车变动】都会跑。 */
  function check(cart) {
    lastCart = cart;
    renderChips(cart);

    var lines = pwpLines(cart);
    if (!lines.length) { tried = {}; return; }

    if (lines.length > 1) {
      var keep = null;
      lines.forEach(function (l) { if (!keep && discounted(l)) keep = l; });
      if (!keep) keep = lines[0];
      var extra = null;
      lines.forEach(function (l) { if (!extra && l !== keep) extra = l; });
      return dropLine(extra);
    }

    var only = lines[0];
    var code = up(only.properties[MARK]);
    if (discounted(only)) { tried = {}; return; }

    /* 折扣掉了。先便宜地补一次码（AJAX，不跳页）；补不回来就移除，绝不让他付原价。 */
    if (!tried[code]) {
      tried[code] = true;
      return setDiscount(code).then(function (state) {
        return getCart().then(function (c2) {
          lastCart = c2;
          var l2 = pwpLines(c2)[0];
          if (l2 && discounted(l2)) { paint(state); renderChips(c2); return; }
          return dropLine(l2 || only);
        });
      });
    }
    return dropLine(only);
  }

  function refresh() {
    if (busy || working) return;
    busy = true;
    getCart().then(check)
      .catch(function (e) { console.warn('[PWP]', e); })
      .then(function () { busy = false; });
  }

  /* 拦截购物车请求：车一动就重新检查 */
  var settle = null;
  function scheduleRefresh() {
    if (settle) clearTimeout(settle);
    settle = setTimeout(function () { settle = null; refresh(); }, 400);
  }
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || String(arguments[0] || '');
    var p = rawFetch.apply(null, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(scheduleRefresh, function () {});
    return p;
  };
  /* 有些主题用 XMLHttpRequest，一并盖住 */
  var rawSend = XMLHttpRequest.prototype.send;
  var rawOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this.__mfUrl = String(u || ''); return rawOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update|clear)/.test(this.__mfUrl || '')) this.addEventListener('load', scheduleRefresh);
    return rawSend.apply(this, arguments);
  };

  function buildBox() {
    var wrap = document.createElement('div');
    wrap.className = 'mf-code-box';
    wrap.style.cssText = 'margin:14px 0;font:inherit';
    var label = document.createElement('div');
    label.textContent = T.label;
    label.style.cssText = 'font-size:12px;letter-spacing:.04em;opacity:.75;margin-bottom:6px';
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px';
    var input = document.createElement('input');
    input.type = 'text'; input.placeholder = T.ph; input.autocomplete = 'off';
    input.style.cssText = 'flex:1;min-width:0;padding:11px 12px;border:1px solid rgba(0,0,0,.22);border-radius:10px;background:#fff;color:#12343b;font:inherit;font-size:14px';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.textContent = T.apply;
    btn.style.cssText = 'padding:11px 18px;border:0;border-radius:10px;background:#12343b;color:#fff;font:inherit;font-size:14px;font-weight:600;cursor:pointer';
    var chips = document.createElement('div');
    chips.className = 'mf-code-chips';
    chips.style.cssText = 'display:none;flex-wrap:wrap;gap:6px;margin-top:9px';
    var msg = document.createElement('p');
    msg.style.cssText = 'display:none;margin:8px 0 0;font-size:12.5px;line-height:1.45;color:#a13b3b';
    if (pendingMsg) { msg.textContent = pendingMsg; msg.style.display = 'block'; }
    row.appendChild(input); row.appendChild(btn);
    wrap.appendChild(label); wrap.appendChild(row); wrap.appendChild(chips); wrap.appendChild(msg);
    btn.addEventListener('click', function () { applyCode(input.value, msg, btn); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyCode(input.value, msg, btn); }
    });
    return wrap;
  }

  var CTX = '.cart__footer, .cart-drawer__footer, .drawer__footer';
  function mount() {
    var added = false;
    document.querySelectorAll(CTX).forEach(function (ctx) {
      if (ctx.parentElement && ctx.parentElement.closest(CTX)) return;
      if (ctx.querySelector('.mf-code-box')) return;
      var anchor = ctx.querySelector('.totals') || ctx.querySelector('.cart__ctas');
      var box = buildBox();
      if (anchor && anchor.parentElement) anchor.parentElement.insertBefore(box, anchor);
      else ctx.insertBefore(box, ctx.firstChild);
      added = true;
    });
    /* 新插的框先用手上资料画，同时去拿最新的购物车重画一次 */
    if (added) { renderChips(lastCart); scheduleRefresh(); }
  }

  var pending = null;
  function scheduleMount() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; mount(); }, 120);
  }

  function maybeReopenDrawer() {
    if (!grab(REOPEN_KEY)) return;
    if (window.location.pathname.indexOf('/cart') === 0) return;
    if (!document.querySelector('cart-drawer')) return;
    setTimeout(function () {
      var opener = document.querySelector('#cart-icon-bubble, .header__icon--cart, button[href="/cart"]');
      if (opener) opener.click();
    }, 500);
  }

  function boot() {
    pendingMsg = grab(MSG_KEY);
    mount();
    refresh();
    maybeReopenDrawer();
    new MutationObserver(scheduleMount).observe(document.body, { childList: true, subtree: true });
    if (pendingMsg) setTimeout(function () { pendingMsg = null; }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
